import { AnchorButton } from "@govlaunch/core";
import * as palette from "@govlaunch/palette";
import Link from "next/link";
import React from "react";
import { FormattedMessage } from "react-intl";
import { IVendorQuery } from "~/lib/queries/__generated__/VendorQuery.generated";
import PenIcon from "~/components/icons/PenIcon";
import VendorProducts from "~/components/vendor/tabs/VendorProducts";

interface IVendorOwnerProductsTab {
  vendor: IVendorQuery["company"];
}

export default function VendorOwnerProductsTab({ vendor }: IVendorOwnerProductsTab) {
  if (!vendor) {
    return null;
  }

  return (
    <>
      <div
        css={{
          width: 180,
          marginBottom: 24,
        }}
      >
        <Link as="/products/new" href="/products/new" passHref={true}>
          <div>
            <AnchorButton
              theme="secondary"
              size="large"
              color={palette.lightestGray}
              textColor={palette.darkGray}
              css={{
                background: "#fff",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <PenIcon />
              <span
                css={{
                  marginLeft: 4,
                  fontSize: 16,
                }}
              >
                <FormattedMessage defaultMessage="New Product" id="C19d91" />
              </span>
            </AnchorButton>
          </div>
        </Link>
      </div>
      <VendorProducts vendor={vendor} />
    </>
  );
}
